import useMutation from "src/hooks/useMutation";

function useConfirmBulkReturnProcessing(id) {
  return useMutation({
    path: `/api/v1/return-logs/${id}/submit`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/return-logs`,
      shouldRevalidate: true,
    },
  });
}

export default useConfirmBulkReturnProcessing;
